/**
 * top row is a blue strip
 * left side show date and time, middle show mutch number, right side show gameStatus
 * below that teamALogo teamAScore vs teamBScore teamBLogo, shrunk (justify content) centrally or space-evenly
 */
import "./MatchResultCard.css";

export default function MatchResultCard({
  matchNumber,
  teamA,
  teamALogo,
  teamAScore,
  teamB,
  teamBLogo,
  teamBScore,
  time,
  date,
  gameStatus,
}) {
  return (
    <div className="result-card">
      {/* Top blue strip */}
      <div className="result-card-header">
        <div className="result-header-datetime">
          <span className="result-date">
            {new Date(date).toLocaleDateString("en-GB", {
              day: "numeric",
              month: "long",
            })}
          </span>
          <span className="result-time">
            {new Date(`1970-01-01T${time}`).toLocaleTimeString("en-US", {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })}
          </span>
        </div>
        <div className="result-match-number">{matchNumber}</div>
        <div className="result-game-status">{gameStatus}</div>
      </div>

      {/* Bottom score row */}
      <div className="result-card-body">
        <div className="result-team">
          <img src={teamALogo} alt={teamA} className="result-team-logo" />
          <span className="result-score">{teamAScore}</span>
        </div>
        <div className="result-vs">vs</div>
        <div className="result-team result-team-b">
          <span className="result-score">{teamBScore}</span>
          <img src={teamBLogo} alt={teamB} className="result-team-logo" />
        </div>
      </div>

      {/* Result summary */}
      {(() => {
        if (!teamAScore && !teamBScore) return null;
        // Parse score: supports plain numbers and tiebreak format "18, 7"
        const parseScore = (s) => {
          const parts = String(s).split(",").map((p) => parseFloat(p.trim()));
          return [isNaN(parts[0]) ? NaN : parts[0], isNaN(parts[1]) ? 0 : parts[1]];
        };
        const [a1, a2] = parseScore(teamAScore);
        const [b1, b2] = parseScore(teamBScore);
        if (isNaN(a1) || isNaN(b1)) return null;
        if (a1 === 0 && b1 === 0) return null;
        const aWins = a1 > b1 || (a1 === b1 && a2 > b2);
        const bWins = b1 > a1 || (b1 === a1 && b2 > a2);
        if (!aWins && !bWins) return (
          <div className="result-summary">Match Tied</div>
        );
        const winner      = aWins ? teamA : teamB;
        const loser       = aWins ? teamB : teamA;
        const winnerScore = aWins ? teamAScore : teamBScore;
        const loserScore  = aWins ? teamBScore : teamAScore;
        return (
          <div className="result-summary">
            {winner} beat {loser} by {winnerScore}–{loserScore}
          </div>
        );
      })()}
    </div>
  );
}
